import * as React from 'react';

import cn from 'classnames';

import { ISpinnerProps } from './types';

import * as s from './Spinner.scss';

export const Spinner = (props: ISpinnerProps) => {
	return (
		<div className={cn(s.loader, props.className)} style={{ width: props.size, height: props.size }}>
			<svg className={s.circular} viewBox="25 25 50 50">
				<circle
					className={s.path}
					cx="50"
					cy="50"
					r="20"
					fill="none"
					stroke={props.color}
					strokeWidth="5"
					strokeMiterlimit="10"
				/>
			</svg>
		</div>);
};

Spinner.defaultProps = {
	size: 100,
};
